// extracted by mini-css-extract-plugin
export default {"component":"Footer_component__LnvQz","component__text":"Footer_component__text__Ud1eL","component__icons":"Footer_component__icons__YI9zY"};